
<div class="goreact-modal">
	<div class="goreact-modal-header">
		<button type="button" class="close-btn" (click)="cancel()" aria-label="Cancel">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<h1 [id]="data.dialogTitleId" translate="user-type-selection-dialog_title"></h1>
		<ul>
			<li>
				<button
					data-cy="instructor-btn"
					class="instructor-btn primary-btn"
					(click)="selectInstructor()">
					<i class="ficon-app-instructor"></i>
					<span translate="instructor"></span>
				</button>
			</li>
			<li>
				<button
					data-cy="student-btn"
					class="student-btn primary-btn"
					(click)="selectPresenter()">
					<i class="ficon-app-presenter"></i>
					<span translate="presenter"></span>
				</button>
			</li>
		</ul>
	</div>
</div>
